// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchTypeSegmented-module__wrapper___gPs41","wrapperWide":"SearchTypeSegmented-module__wrapperWide___IkK3C"};